import { StyledText } from '@clickcease/cc-client-components-lib'
import { Trans, useTranslation } from 'react-i18next'

import { HelpCenterRedirect } from '../HelpCenterRedirect/HelpCenterRedirect'
import { ZENDESK_LINKS } from '../../utils/zendeskLinks'

import { DescriptionContainer } from './MicrosoftAudienceModal.styled'
import React from 'react'

export const MicrosoftAudienceDescription = () => {
  const { t } = useTranslation('PMPlatforms')

  return (
    <DescriptionContainer>
      <StyledText variant={'baseLight'}>
        <Trans ns="PMPlatforms" i18nKey="microsoft-audience-modal.description1">
          1.
          <HelpCenterRedirect text="Create" article={ZENDESK_LINKS.msAudienceExclusion} /> a new UET
          tag and paste it below.
        </Trans>
      </StyledText>
      <StyledText variant={'baseLight'}>{t('microsoft-audience-modal.description2')}</StyledText>
      <StyledText variant={'baseLight'}>
        <Trans ns="PMPlatforms" i18nKey="microsoft-audience-modal.description3">
          3.
          <HelpCenterRedirect text="Set up" article={ZENDESK_LINKS.msCreateAudienceExclusion} /> an
          audience on Microsoft. Make sure you have the
          <HelpCenterRedirect
            text="tracking parameters"
            article={ZENDESK_LINKS.msWhereToFindDomainTrackingParameters}
          />{' '}
          added.
        </Trans>
      </StyledText>
    </DescriptionContainer>
  )
}
